
const DrawSVGUtils = require('../../../viscomjs/utils/DrawSVGUtils');
const utils = {};
DrawSVGUtils.mixin(utils);

module.exports.constructSectors = (svg, r, num, w, opacity) => {

    const g = svg.g();
    const els = [];
    const dR = 2 * Math.PI / num;
    const c = [0, 0];

    let i;
    for (i = 0; i < num; i++) {
        els.push(svg.line(...c.concat(_getRayPoint(r, dR * i)))
            .attr({
                stroke: '#fff',
                opacity: opacity
            })
            .appendTo(g)
        );
    }

    g.data({
        lines: els,
        dR: dR,
        r: r,
        R: r,
        cx: c[0],
        cy: c[1],
        centerChanged: false,
        rChanged: false
    });

    return g;
};

const changeSectorsCenter = (g, cx, cy) => {

    const els = g.data('lines');

    let i;
    for (i = 0; i < els.length; i++) {
        els[i]
            .attr({
                x1: cx,
                y1: cy
            });
    }

    g.data({
        cx: cx,
        cy: cy,
        centerChanged: false
    });

    return g;
};

const changeSectorsRadius = (g, r) => {

    const els = g.data('lines');
    const dR = g.data('dR');

    let i;
    let p;
    for (i = 0; i < els.length; i++) {
        p = _getRayPoint(r, dR * i);
        els[i]
            .attr({
                x2: p[0],
                y2: p[1]
            });
    }

    g.data({
        r: r,
        rChanged: false
    });

    return g;
};

const changeSectorsCenterAndRadius = (g, r, cx, cy) => {

    const els = g.data('lines');
    const dR = g.data('dR');

    let i;
    let p;
    for (i = 0; i < els.length; i++) {
        p = _getRayPoint(r, dR * i);
        els[i]
            .attr({
                x1: cx,
                y1: cy,
                x2: p[0],
                y2: p[1]
            });
    }

    g.data({
        r: r,
        cx: cx,
        cy: cy,
        centerChanged: false,
        rChanged: false
    });

    return g;
};

module.exports.constructFineSectors = (svg, r, num, num2, wA, opacity) => {
    const dR = 2 * Math.PI / (num * num2);
    const wR = wA * Math.PI / 180;
    const arr = _getFineSectorsPoints(r, [0, 0], num, num2, dR, wR);


    const el = svg.polyline(arr)
        .attr({
            fill: '#fff',
            opacity: opacity
        });

    el.data({
        num: num,
        num2: num2,
        dR: dR,
        wR: wR,
        points: arr,
        cx: 0,
        cy: 0,
        r: r,
        R: r,
        centerChanged: false,
        rChanged: false
    });

    return el;
};

const changeFineSectorsCenter = (el, c) => {
    const arr = el.data('points');
    let i = 0;
    let j = 0;
    while (i < arr.length) {
        if (j < 2) arr[i] = c[j];
        j++;
        if (j > 5) j = 0;
        i++;
    }
    el.attr({
        points: arr
    })
    .data({
        points: arr,
        cx: c[0],
        cy: c[1],
        centerChanged: false
    });
};

const changeFineSectorsRadius = (el, r) => {
    const arr = el.data('points');
    let p;

    const num = el.data('num');
    const num2 = el.data('num2');
    const dR = el.data('dR');
    const wR = el.data('wR');

    let i;
    let j;
    let k = 2;
    for (i = 0; i < num; i++) {
        /* if (b) {
         arr = arr.concat(_getAngleRayPoints(r, dR * (i * num2), wR / 2));
         arr = arr.concat(c);
         }*/

        for (j = 1; j < num2; j++) {
            p = _getAngleRayPoints(r, dR * (i * num2 + j), wR / 2);

            while (p.length > 0) {
                arr[k] = p.shift();
                k++;
            }

            k += 2;
        }
    }

    el.attr({
        points: arr
    })
    .data({
        points: arr,
        r: r,
        rChanged: false
    });
};

const changeFineSectorsCenterAndRadius = (el, r, c) => {
    const num = el.data('num');
    const num2 = el.data('num2');
    const dR = el.data('dR');
    const wR = el.data('wR');

    const arr = _getFineSectorsPoints(r, c, num, num2, dR, wR);

    el.attr({
        points: arr
    })
    .data({
        points: arr,
        cx: c[0],
        cy: c[1],
        centerChanged: false,
        r: r,
        rChanged: false
    });
};

module.exports.changeSectorsCenter = changeSectorsCenter;
module.exports.changeSectorsRadius = changeSectorsRadius;
module.exports.changeSectorsCenterAndRadius = changeSectorsCenterAndRadius;
module.exports.changeFineSectorsCenter = changeFineSectorsCenter;
module.exports.changeFineSectorsRadius = changeFineSectorsRadius;
module.exports.changeFineSectorsCenterAndRadius = changeFineSectorsCenterAndRadius;

module.exports.updateSectors = (el, source) => {
    const centerChanged = source.data('centerChanged');
    const rChanged = source.data('rChanged');

    if (centerChanged && rChanged) {
        changeSectorsCenterAndRadius(el, source.data('r'), source.data('cx'), source.data('cy'));
        return;
    }
    if (centerChanged) {
        changeSectorsCenter(el, source.data('cx'), source.data('cy'));
        return;
    }
    if (rChanged) {
        changeSectorsRadius(el, source.data('r'));
    }
};

module.exports.updateFineSectors = (el, source) => {
    const centerChanged = source.data('centerChanged');
    const rChanged = source.data('rChanged');

    if (centerChanged && rChanged) {
        changeFineSectorsCenterAndRadius(el, source.data('r'), [source.data('cx'), source.data('cy')]);
        return;
    }
    if (centerChanged) {
        changeFineSectorsCenter(el, [source.data('cx'), source.data('cy')]);
        return;
    }
    if (rChanged) {
        changeFineSectorsRadius(el, source.data('r'));
    }
};

const _getRayPoint = (r, a) => {
    return [r * Math.cos(a), -r * Math.sin(a)];
};

const _getAngleRayPoints = (r, a, wA2) => {
    return [r * Math.cos(a - wA2), -r * Math.sin(a - wA2), r * Math.cos(a + wA2), -r * Math.sin(a + wA2)];
};

const _getFineSectorsPoints = (r, c, num, num2, dR, wR) => {

    let arr = [].concat(c);

    let i;
    let j;
    for (i = 0; i < num; i++) {
        /* if (b) {
         arr = arr.concat(_getAngleRayPoints(r, dR * (i * num2), wR / 2));
         arr = arr.concat(c);
         }*/

        for (j = 1; j < num2; j++) {
            arr = arr.concat(_getAngleRayPoints(r, dR * (i * num2 + j), wR / 2));
            arr = arr.concat(c);
        }
    }

    return arr;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/svgAnim/DrawSectorsUtils.js